import type { Image } from "../../aysa_api/models/image.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  encodeAspectRatio,
  decodeAspectRatio,
} from "../../aysa_api/models/aspect_ratio";

export const createBaseImage = (): Image => {
  return {
    url: "",
    description: "",

    external: false,
  };
};

export const decodeImage = (reader: Reader, length: number): Image => {
  const end = reader.pos + length;
  const message = createBaseImage();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.url = reader.string();

        break;
      case 2:
        message.description = reader.string();

        break;
      case 3:
        message.aspectRatio = decodeAspectRatio(reader, reader.uint32());

        break;
      case 4:
        message.external = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeImage = (writer: Writer, message: Image): Writer => {
  writer.uint32(10).string(message.url);
  writer.uint32(18).string(message.description);
  if (message.aspectRatio !== undefined) {
    encodeAspectRatio(writer.uint32(26).fork(), message.aspectRatio).ldelim();
  }
  writer.uint32(32).bool(message.external);

  return writer;
};
